export default {
  List: {
    BudgetGroupItem: 'Nhóm mục chi',
  },
  Detail: {
    BudgetExpenseGroupItemCode: 'Mã nhóm mục chi *',
    BudgetExpenseGroupItemName: 'Tên nhóm mục chi *',
  },
};
